import "./App.css";
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import Login from "./page/Login";
import Signup from "./page/Signup";
import ForgotPassword from "./page/FortgotPassword";
import AuthLayout from "./layout/AuthLayout";
import DashboardLayout from "./layout/DashboardLayout";
import Signin from "./page/Signin";
import "react-datepicker/dist/react-datepicker.css";
import { useContext, useEffect, useState } from "react";
import CreateAccountant from "./page/CreateAccountant";
import LoginAccountant from "./page/LoginAccountant";
import {
  ConfigurationSideBar,
  FiananceSideBar,
  HistorySideBar,
  LedgerSideBar,
  HomeSidebar,
  AdministraionSideBar,
  ReportSideBar,
} from "finex-web";
import { ConfigurationSideBarInventory } from "inventory-web";
import LanguageContext from "./context/LanguageContext";
import LoginNewUser from "./page/LoginNewUser";
import AccountInfor from "./page/AccountInfor";
import ProtectedRoute from "./context/ProtectedRoute";
import { ModulesProvider } from "./context/ModulesContext";
import { currentLanguage } from "./context/languageSegment";
import AppErrorBoundary from "./context/AppErrorBoundary";
import RouteManager from "./route/RouteManager";
import ForbiddenPage from "./ForbiddenPage";
import SalesReports from "./page/SalesReports";

function BrowseRouterApp() {
  const { language } = useContext(LanguageContext);
  const location = useLocation();
  // First segment only counts as the language when it IS one; a page name
  // there (a language-less URL) must not re-key every route under itself.
  const pathLanguage = currentLanguage(location.pathname);
  const tokens = localStorage.getItem("accessToken");

  const [listHome] = useState<any>([
    {
      id: "1",
      name: language["Home"] ? language["Home"] : "Home",
      value: [...HomeSidebar, ...ConfigurationSideBarInventory],
    },
    {
      id: "2",
      name: language["Fiance"] ? language["Fiance"] : "Fiance",
      value: FiananceSideBar,
    },
    {
      id: "3",
      name: language["Configuration"]
        ? language["Configuration"]
        : "Configuration",
      value: ConfigurationSideBar,
    },
    {
      id: "4",
      name: language["Ledger"] ? language["Ledger"] : "Ledger",
      value: [...HistorySideBar, ...LedgerSideBar],
    },
    {
      id: "5",
      name: language["Administration"]
        ? language["Administration"]
        : "Administration",
      value: AdministraionSideBar,
    },
    {
      id: "6",
      name: language["Reports"] ? language["Reports"] : "Reports",
      value: ReportSideBar,
    },
  ]);

  useEffect(() => {
    const pathRedirect = location.pathname.split("/")[1];
    if (
      pathRedirect === "loginAccountant" ||
      pathRedirect === "createAccountant" ||
      pathRedirect === "loginNewUser"
    ) {
      localStorage.clear();
    }
    // setPathLanguage(pathRedirect || "en");
  }, [location, listHome]);

  return (
    <Routes>
      {tokens ? (
        <>
          {/* Outside DashboardLayout (no sidebar, no header) but inside the
              signed-in branch: a visitor with no session must land on the
              sign-in screen, not on "ask an administrator for permission". */}
          <Route
            path={`/${pathLanguage}/403`}
            element={<ForbiddenPage />}
          />
          <Route path="/" element={<DashboardLayout />}>
          {listHome
            .flatMap((group: any) => group.value)
            .map((item: any) => (
              <Route
                key={item.path}
                path={`/${pathLanguage}${item.path}`}
                element={
                  <ProtectedRoute requiredModule={item.component}>
                    <item.component />
                  </ProtectedRoute>
                }
              />
            ))}
          <Route
            path={`/${pathLanguage}/accountInfor`}
            element={<AccountInfor />}
          />
          <Route
            path={`/${pathLanguage}/report/:id`}
            element={<SalesReports />}
          />
          {/* Nếu vào đường dẫn không hợp lệ, redirect về dashboard */}
          <Route
            path="*"
            element={<Navigate to={`/${pathLanguage}/dashboard`} replace />}
          />
          </Route>
        </>
      ) : (
        <Route path="/" element={<AuthLayout />}>
          <Route path="*" element={<Navigate to="/" />} />
          <Route index element={<Signin />} />
          <Route path="/login" element={<Signin />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/resetPassword" element={<ForgotPassword />} />
          <Route path="/createAccountant/:id" element={<CreateAccountant />} />
          <Route path="/loginAccountant/:id" element={<LoginAccountant />} />
          <Route path="/loginNewUser/:id" element={<LoginNewUser />} />
        </Route>
      )}
    </Routes>
  );
}

// The boundary needs the pathname so leaving a crashed page recovers the app.
function GuardedApp() {
  const location = useLocation();
  return (
    <AppErrorBoundary pathname={location.pathname}>
      <BrowseRouterApp />
    </AppErrorBoundary>
  );
}

// Wrap App with ModulesProvider
function App() {
  return (
    <BrowserRouter>
      <RouteManager />
      <ModulesProvider>
        <GuardedApp />
      </ModulesProvider>
    </BrowserRouter>
  );
}

export default App;
